// @flow weak

import { appConfig }  from '../../config';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
  jsonHeader,
  postMethod,
  multipartJsonHeader,
}                     from '../fetchTools';

var options = {...defaultOptions, ...jsonHeader};
export const getGameInfoData = (name, params) => {
    console.log("sh get API ")
    console.log(name)
    if (params == null){
        params="";
    }
    const url = `${getLocationOrigin(1)}/${appConfig.gameinfo.data.API}${appConfig.gameinfo.data[name].path}/${params}`
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => data)
    .catch(error => error);
};



// WEBPACK FOOTER //
// ./src/app/services/API/gameinfo.js